/**
 * Fades page sections in as they scroll into view.
 * Content stays visible without JavaScript, in the theme editor, and for
 * visitors who prefer reduced motion: the hidden state only applies once
 * this script adds `yume-motion` to <html>.
 */
const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
const designMode = Boolean(window.Shopify && window.Shopify.designMode);

function init() {
  if (reducedMotion.matches || designMode || !('IntersectionObserver' in window)) return;

  // The first section (hero) is above the fold, so it is never hidden.
  const sections = [...document.querySelectorAll('main > .shopify-section')].slice(1);
  if (sections.length === 0) return;

  const observer = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        entry.target.classList.add('is-revealed');
        observer.unobserve(entry.target);
      }
    },
    { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
  );

  for (const section of sections) {
    // Sections already on screen at load are shown immediately, without animation.
    const { top } = section.getBoundingClientRect();
    if (top < window.innerHeight) continue;
    section.classList.add('yume-reveal');
    observer.observe(section);
  }

  document.documentElement.classList.add('yume-motion');
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init, { once: true });
} else {
  init();
}
